const routes = [
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      requireAuth: false,
    },
    component: () => import("@/views/Dashboard.vue"),
  },
  {
    path: "/dashboard/painel",
    name: "painel-dashboard",
    meta: {
      requireAuth: false,
    },
    component: () => import("@/views/PainelDashboard/PainelDashboard.vue"),
  },
  {
    path: "/dashboard/carencia-professores",
    name: "dashboard-carencia-professores-detalhe",
    meta: {
      requireAuth: false,
    },
    component: () =>
      import(
        "@/views/PainelDashboard/carencia-professores/DashboardCarenciaProfessoresDetalhe.vue"
      ),
  },
  {
    path: "/dashboard/lotacao-servidores",
    name: "dashboard-lotacao-servidores-detalhe",
    meta: {
      requireAuth: false,
    },
    component: () =>
      import(
        "@/views/PainelDashboard/lotacao-servidores/DashboardQuadroServidoresDetalhe.vue"
      ),
  },
  {
    path: "/dashboard/afastamentos",
    name: "dashboard-afastamentos-detalhe",
    meta: {
      requireAuth: false,
    },
    component: () =>
      import(
        "@/views/PainelDashboard/afastamentos/DashboardAfastamentosDetalhe.vue"
      ),
  },
  {
    path: "/dashboard/pedidos",
    name: "dashboard-pedidos-detalhe",
    meta: {
      requireAuth: false,
    },
    component: () =>
      import("@/views/PainelDashboard/pedidos/DashboardPedidosDetalhe.vue"),
  },
];

export default routes;
